import { useCallback } from 'react'
import {
  ApiGetWithToken,
	ApiPostWithToken,
	ApiPatchWithToken,
	ApiDeleteWithToken,
	useApiFetch,
	useApiPost
} from 'shared/api'
import {
	searchsAuthorApiBy
} from 'interface/endpoints'
import {
	InterestFormData,
  InterestResult,
  InterestResultList
} from './types'

export * from './types'

export const useListInterest = (
	searchId: number | null | undefined,
	authorId: number | null | undefined
) => useApiFetch(
	useCallback(
		(apiAccess, cancelToken) => {
			if (!searchId || !authorId) return null
      return ApiGetWithToken<InterestResultList>(
        apiAccess,
        searchsAuthorApiBy(searchId, authorId, '/interest/list'),
        cancelToken
      )
    },
		[searchId, authorId]
	)
)

export const usePostInterest = (
	searchId: number,
	authorId: number,
  callback?: {
    onPosted?: (result: InterestResult) => void
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    onError?: (reason: any) => void
  }
) => useApiPost<InterestFormData, InterestResult>(
	useCallback(
		(apiAccess, cancelToken, form, webSocketId) => {
			return ApiPostWithToken(
				apiAccess,
        searchsAuthorApiBy(searchId, authorId, '/interest'),
				form,
				cancelToken,
				webSocketId
			)
		},
		[searchId, authorId]
	),
	useCallback(
		(result) => {
			if (callback?.onPosted) callback.onPosted(result)
			return result
		},
		[callback]
	),
	useCallback(
		(reason) => {
      if (callback?.onError) callback?.onError(reason)
		},
		[callback]
	)
)

export const useEditInterest = (
	searchId: number, 
	authorId: number,
  callback?: {
    onEditted?: (result: InterestResult) => void
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    onError?: (reason: any) => void
  }
) => useApiPost<{ interestId: number, form: InterestFormData }, InterestResult>(
	useCallback(
		(apiAccess, cancelToken, { interestId, form }, webSocketId) => {
			return ApiPatchWithToken(
				apiAccess,
        searchsAuthorApiBy(searchId, authorId, `/interest/${interestId}`),
				form,
				cancelToken,
				webSocketId
			)
		},
		[searchId, authorId]
	),
	useCallback(
		(result) => {
			if (callback?.onEditted) callback.onEditted(result)
			return result
		},
		[callback]
	),
	useCallback(
		(reason) => {
      if (callback?.onError) callback?.onError(reason)
		},
		[callback]
	)
)

export const useDeleteInterest = (
	searchId: number,
	authorId: number,
  callback?: {
    onDeleted?: (interestId: number) => void
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    onError?: (reason: any) => void
  }
) => useApiPost<number, number>(
	useCallback(
		(apiAccess, cancelToken, interestId, webSocketId) => {
			return ApiDeleteWithToken(
				apiAccess,
        searchsAuthorApiBy(searchId, authorId, `/interest/${interestId}`),
				cancelToken,
				webSocketId
			)
		},
		[searchId, authorId]
	),
	useCallback(
		(result) => {
			if (callback?.onDeleted) callback.onDeleted(result)
			return result
		},
		[callback]
	),
	useCallback(
		(reason) => {
      if (callback?.onError) callback?.onError(reason)
		},
		[callback]
	)
)
